import { gridFiltersService } from '@components-library/Grid/GridHeader/gridFilters.service';
import { keyMap } from '@locales/lokalise/keyMap';
import { ENUM_DATE_TIME_RANGE, getAll, getCurrentDayUtc } from '@utils/library/dateTime';

export const dateTimeRangeOptionsWithoutAll = [
  {
    key: ENUM_DATE_TIME_RANGE.currentDay,
    title: keyMap.formsDataRangeCurrentDayOption,
    getRange: gridFiltersService.getCurrentPlatformDayRange,
  },
  {
    key: ENUM_DATE_TIME_RANGE.pastDay,
    title: keyMap.formsDataRangePastDayOption,
    getRange: gridFiltersService.getPastPlatformDayRange,
  },
  {
    key: ENUM_DATE_TIME_RANGE.currentMonth,
    title: keyMap.formsDataRangeCurrentMonthOption,
    getRange: gridFiltersService.getCurrentPlatformMonthRange,
  },
  {
    key: ENUM_DATE_TIME_RANGE.pastMonth,
    title: keyMap.formsDataRangePastMonthOption,
    getRange: gridFiltersService.getPastPlatformMonthRange,
  },
  {
    key: ENUM_DATE_TIME_RANGE.custom,
    title: keyMap.formsDataRangeCustomOption,
    getRange: () => Object.assign({}, { ...getCurrentDayUtc(), range: ENUM_DATE_TIME_RANGE.custom }),
  },
];

export const dateTimeRangeOptions = [
  { key: ENUM_DATE_TIME_RANGE.all, title: keyMap.formsDataRangeAllOption, getRange: getAll },
  ...dateTimeRangeOptionsWithoutAll,
];
